module.exports = ele2Extend.tools;


//////////////////
// WEBPACK FOOTER
// external "ele2Extend.tools"
// module id = SpMV
// module chunks = 17